import { useDispatch, useSelector } from 'react-redux';
import FJWatermarkRemoverRight from '../view/FJWatermarkRemoverRight';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import FJActionWatermarkRemover from '../../../../redux/action/FJActionWatermarkRemover';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useState } from 'react';
import FJActionCommon from '../../../../redux/action/FJActionCommon';

const FJWatermarkRemoverRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    // Redux状态
    const taskStatus = useSelector(state => state.common.taskStatus);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const isCanDownload = useSelector(state => state.common.isDone);
    const creationList = useSelector(state => state.common.creationList);
    const [downloadLoading, setDownloadLoading] = useState(false);

    const uploadImg = file => {
        dispatch(FJActionWatermarkRemover.uploadImageAction(file));
    };

    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const handleDownload = () => {
        setDownloadLoading(true);
        dispatch(
            FJActionCommon.multiDownloadAction(
                creationList.map(item => item.id),
                'creation',
                () => setDownloadLoading(false),
            ),
        );
    };

    const onRetry = id => {
        dispatch(FJActionWatermarkRemover.onRetryAction(id));
    };

    const imageToVideo = () => {
        dispatch(FJActionCommon.imageToVideoAction());
    };

    return (
        <FJWatermarkRemoverRight
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
            taskStatus={taskStatus}
            headerTabIndex={headerTabIndex}
            isCanDownload={isCanDownload}
            onDownload={handleDownload}
            downloadLoading={downloadLoading}
            onRetry={onRetry}
            imageToVideo={imageToVideo}
        />
    );
};

export default FJWatermarkRemoverRightContainer;
